import { render, staticRenderFns } from "./cartTrapezGS.vue?vue&type=template&id=c6edb0dc&"
import script from "./cartTrapezGS.vue?vue&type=script&lang=js&"
export * from "./cartTrapezGS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports